import * as generic from '@/store/generic/mutations/result-status.js'

export function clearError (state, payload) {
  generic.clearError(state, payload)
}

export function setError (state, payload) {
  generic.setError(state, payload)
}

export function setSuccess (state, payload) {
  generic.setSuccess(state, payload)
}

export function setProcessing (state, payload) {
  generic.setProcessing(state, payload)
}

export function setInitializing (state, payload) {
  generic.setInitializing(state, payload)
}

export function setEventLogs (state, payload) {
  state.eventLogs = payload
}

export function setLoginLogs (state, payload) {
  state.loginLogs = payload
}

export function setTransactionLogs (state, payload) {
  state.transactionLogs = payload
}

export function setImportLogs (state, payload) {
  state.importLogs = payload
}

export function delImportLog (state, payload) {
  const importLogs = state.importLogs.filter(res => res.id !== payload.id)
  state.importLogs = importLogs || []
}

export function setMenus (state, payload) {
  state.menus = payload
}

export function setSubMenus (state, payload) {
  state.subMenus = payload
}

export function setRole (state, payload) {
  state.role = payload
}

export function setRoles (state, payload) {
  state.roles = payload
}

export function delRole (state, payload) {
  const roles = state.roles.filter(res => res.id !== payload.id)
  state.roles = roles || []
}

export function setMaintenances (state, payload) {
  state.maintenances = payload
}

export function setConfig (state, payload) {
  state.config = payload
}

export function setConfigSigner (state, payload) {
  state.configSigner = payload
}
